var sharePopupDefaultOptions = {
    popupSelector: null,
};

function SharePopup(options) {
    var settings = $.extend({}, sharePopupDefaultOptions, options);
    this.$popup = $(settings.popupSelector);
    this.$buttonConfirm = $("a.confirm", this.$popup);
    this.$buttonCancel = $("a.cancel", this.$popup);

}

SharePopup.prototype.show = function () {

    var dfd = $.Deferred(), that = this;

    if ((!this.$buttonCancel || !this.$buttonCancel.length) && (!this.$buttonConfirm || !this.$buttonConfirm.length)) {
        dfd.resolve();
        return dfd.promise();
    }
    this.$buttonCancel.click(function () {
        dfd.reject();
        that.$popup.hide();
    });
    this.$buttonConfirm.click(function () {
        dfd.resolve();
        that.$popup.hide();
    });

    this.$popup.show();
    return dfd.promise();

};

function reloadImage() {
    //console.log("img error");
    var img = $(this);

    setTimeout(function () {

        img.attr("src", img.attr("src"));
        //console.log("reloaded");
    }, 500);
};

function loadingWait() {
    $("body").addClass("loading-cursor");
}

function loadingStop() {
    $("body").removeClass("loading-cursor");
}

function scrollToAnchor(element) {
    $('html, body').animate({ scrollTop: $($.attr(element, 'href')).offset().top }, 500); return false;
}

export const ui = {
    SharePopup: SharePopup,
    reloadImage: reloadImage,
    loadingWait: loadingWait,
    loadingStop: loadingStop,
    scrollToAnchor: scrollToAnchor
};